import { Switch } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { CtyButton } from '../button/CtyButton';

export interface McpToolMappingControlsProps {
    readonly isEnabled: boolean;
    readonly isSwitchDisabled: boolean;
    readonly canEdit: boolean;
    readonly isLoading: boolean;
    readonly onEdit: () => void;
    readonly onSwitchChange: (enabled: boolean) => void;
    readonly showLabel?: boolean;
}

export function McpToolMappingControls({
    isEnabled,
    isSwitchDisabled,
    canEdit,
    isLoading,
    onEdit,
    onSwitchChange,
    showLabel = true,
}: McpToolMappingControlsProps) {
    const { t } = useTranslation();

    return (
        <>
            {showLabel ? (
                <span className="text-sm font-medium text-foreground">{t('MCP Tool Mapping')}</span>
            ) : null}
            <CtyButton
                isIconOnly
                size="sm"
                variant="light"
                tooltipContent={
                    !canEdit && !isLoading
                        ? t('Enable MCP tool mapping with the switch to edit tool details')
                        : t('Edit MCP Tool')
                }
                title={t('Edit MCP Tool')}
                isDisabled={!canEdit || isLoading}
                onPress={onEdit}
            >
                <Icon icon="material-symbols:edit-outline-rounded" width="18" height="18" />
            </CtyButton>
            <Switch
                size="sm"
                color="success"
                isSelected={isEnabled}
                isDisabled={isSwitchDisabled}
                onValueChange={onSwitchChange}
                aria-label={t('MCP Tool Mapping')}
            />
            <span className={`text-sm font-medium ${isEnabled ? 'text-success' : 'text-default-400'}`}>
                {isEnabled ? t('Enabled') : t('Disabled')}
            </span>
        </>
    );
}
